/**
 * multiplyPx curryable function:
 * const doublePx = multiplyPx(2);
 * doublePx('24px')
 *
 * @param {number} i multiplication amount
 * @param {string} s string with pixel unit
 * @returns {string} multiplied string with px suffix
 */
export const multiplyPx = (i) => (s) => `${i * parseInt(s, 10)}px`;

export const addSubPx = (i) => (s) => `${i + parseInt(s, 10)}px`;

export const absoluteCenter = () => `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const removeListStyles = `
  list-style-type: none;
  padding: 0;
  margin: 0;
`;
